import { PersonType } from 'models';
import { FC, createContext, useContext, useState, useEffect } from 'react';

import { data as staticDataUz } from 'data-uz';
import { data as staticDataRu } from 'data-ru';
//import { buildPeopleObjects } from 'utils';
import { config } from 'config';

type DataContextType = {
  people: PersonType[];
  //otherLangPeople: PersonType[];
  setPeople: (people: PersonType[]) => void;
  //fetchOtherLangData: () => Promise<PersonType[]>;
  appLocale: typeof config.locale;
  //updatedDate: string;
};

const DataContext = createContext<DataContextType | null>(null);

export const DataProvider: FC = ({ children }) => {
  const params = new URLSearchParams(window.location.search);
  const appLocale = (params.get('lang') || config.locale) as typeof config.locale;
  //const [updatedDate, setUpdatedDate] = useState('');
  const [people, setPeople] = useState<PersonType[]>(
    config.locale === 'uz' ? staticDataUz : staticDataRu
    //buildPeopleObjects(config.locale === 'uz' ? staticDataUz : staticDataRu)
  );
  //console.log(people);
  //const [otherLangPeople, setOtherLangPeople] = useState<PersonType[]>([]);

  useEffect(() => {
    fetch(`${process.env.PUBLIC_URL}/data.json`)
      .then((res) => res.json())
      .then((res) => {
        setPeople(res.data);
      })
      .catch((err) => {
        console.log('error', err);
      });
  }, []);

  /*const fetchOtherLangData = () =>
    fetch(`${process.env.PUBLIC_URL}/data.json`)
      .then((res) => res.json())
      .then((res) => {
        const p = buildPeopleObjects(res);
        setOtherLangPeople(p);
        return p;
      });*/

  return (
    <DataContext.Provider
      value={{
        people,
        setPeople,
        appLocale,
        /*updatedDate,
        fetchOtherLangData,
        otherLangPeople,*/
      }}
    >
      {children}
    </DataContext.Provider>
  );
};

export const useDataContext = () => {
  const context = useContext(DataContext);
  return context as DataContextType;
};
